<template>
  <div class="viewpoint">
    <div class="viewpoint-title">
      敬在的观点与优势
    </div>
    <div class="viewpoint-content">
      <div v-for="(viewpoint, viewpointIndex) in viewpointList" :key="viewpointIndex" class="viewpoint-item">
        <div class="viewpoint-img">
          <el-image class="viewpoint-item-img" :key="viewpoint.src" :src="viewpoint.src" lazy></el-image>
        </div>
        <div class="viewpoint-item-title"
          @click="toPage(`/viewpointsAdvantages?scrollTop=600&activeTab=${viewpointIndex}`)">
          <div>{{ viewpoint.title }}</div>
        </div>
        <div class="viewpoint-item-info">{{ viewpoint.info }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from '../../../constant/config.js'
import { toPage } from "@/utils";

export default {
  data() {
    return {
      viewpointList: config.viewpoint
    }
  },
  mounted() {
  },
  methods: {
    toPage
  },

}
</script>

<style lang="less" scoped>
.viewpoint {
  background-color: @mainBgColor;
  height: 677px;
  color: @mainTextColor;
  display: flex;
  flex-direction: column;
  padding: @commonPadding;

  .viewpoint-title {
    font-size: 40px;
    line-height: 40px;
    margin-bottom: 60px;
  }

  .viewpoint-content {
    display: grid;
    grid-template-columns: repeat(3, calc((100vw - 136px - 44px) / 3));
    grid-column-gap: 22px;

    .viewpoint-item {
      display: flex;
      flex-direction: column;

      .viewpoint-img {
        overflow: hidden;
      }

      .viewpoint-item-img {
        width: 100%;
        height: 323px;

        &:hover {
          cursor: pointer;
          animation-name: scaleImage;
          animation-duration: 0.6s;
          animation-fill-mode: forwards;
          object-fit: cover;
          font-family: 'object-fit:cover;';
        }
      }

      .viewpoint-item-title {
        margin-top: 20px;
        margin-bottom: 8px;
        font-size: 20px;

        cursor: pointer;
        width: fit-content;
        border-bottom: 1px solid transparent;

        &:hover {
          color: @mainTextColor;
          border-bottom: 1px solid @mainTextColor;
        }
      }

      .viewpoint-item-info {
        font-size: 16px;
        color: @mainGrayColor;
      }
    }
  }
}

@media @mobile {
  .viewpoint {
    padding: 46px @commonPadding_h5;
    height: 100%;

    .viewpoint-title {
      font-size: @fontSize24;
      margin-bottom: 40px;
    }

    .viewpoint-content {
      display: flex;
      flex-direction: column;
      gap: 40px;
    }
  }
}


@keyframes scaleImage {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.1);
  }
}
</style>